import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import { Spin } from 'antd';

class LocalizationInitializer extends React.Component {
	state = { isLoading: true };

	constructor(props) {
		super(props);

		const localizationKeys = this.getLocalizationKeys();
		const baseUrl = process.env.REACT_APP_LOCALIZATION_API_URL;
		const cultureCode = this.getLocalizationLanguage();
		const localizationServiceUrl = `${baseUrl}/api/v1/translations/${cultureCode}`;

		fetch(localizationServiceUrl, {
			method: 'POST',
			headers: {
				'Access-Control-Allow-Origin': '*',
				'Content-Type': 'application/json',
			},
			mode: 'cors',
			body: JSON.stringify(localizationKeys),
		})
			.then(response => response.json())
			.then(localizations => {
				this.setState({ isLoading: false });

				const globalTranslations = this.getGlobalTranslations(
					localizations,
				);

				this.initializeLocalization(globalTranslations, cultureCode);
			});
	}

	getLocalizationLanguage = () => {
		const params = new URLSearchParams(this.props.location.search);
		return params.get('cultureCode') || 'en';
	};

	getLocalizationKeys = () => {
		return [
			'back',
			'by_author_x',
			'cancel',
			'cancel',
			'collections',
			'communities_description',
			'community_wizard_all_set',
			'community_wizard_and_more',
			'community_wizard_communities_allow_you_to',
			'community_wizard_feel_more_personal',
			'community_wizard_get_started',
			'community_wizard_if_you_want_to_send_review',
			'community_wizard_if_you_want_to_share',
			'community_wizard_manage_memberships',
			'community_wizard_questions',
			'community_wizard_share_reviews',
			'community_wizard_user_instructions',
			'community_wizard_view_reviews',
			'created_by',
			'created',
			'days_ago',
			'do_not_show_me_this_again',
			'done',
			'general_interest_communities_current',
			'general_interest_communities_description',
			'general_interest_communities_eligible',
			'general_interest_communities_note',
			'general_interest_communities',
			'genre_communities_description',
			'genre_communities_disclaimer',
			'genre_communities',
			'important_note',
			'invalid_access_code',
			'join',
			'loading_available_communities',
			'loading_joined_communities',
			'minutes_ago',
			'much_love',
			'next',
			'no_access_code',
			'one_minute_ago',
			'over_an_hours_ago',
			'over_x_hours_ago',
			'overall_rating',
			'published_by_x',
			'rating',
			'remind_me_later',
			'review_of_x',
			'review',
			'reviews',
			'shared',
			'skip',
			'submitted_by',
			'type',
			'updated',
			'user',
			'users_within_a_community_can',
			'verifying',
			'word_share',
			'word_view',
			'yesterday',
			'your_edelweiss_communities',
			'created',
			'collections',
			'over_an_hour_ago',
			'no_review_written',
		];
	};

	getGlobalTranslations(localizations) {
		var globalTranslations = localizations.reduce(
			(result, localization) => {
				result[localization.key] = localization.value;
				return result;
			},
			{},
		);
		return globalTranslations;
	}

	initializeLocalization = (globalTranslations, cultureCode) => {
		this.props.initialize({
			languages: [
				{
					name: `Language of culture code '${cultureCode}'`,
					code: cultureCode,
				},
			],
			translation: globalTranslations,
			options: { renderToStaticMarkup },
		});
	};

	render() {
		if (this.state.isLoading) {
			return (
				<Spin>
					<div id="localization-loading" />
				</Spin>
			);
		}

		return this.props.children;
	}
}

export default withRouter(withLocalize(LocalizationInitializer));
